export const RESET_LINESETS_CONFIRM_TITLE = 'Reset Line Sets?';

export const RESET_LINESETS_CONFIRM_MESSAGE =
  'This will remove all line sets from this configuration. Do you want to continue?';

export const RESET_LINESETS_CONFIRM_BUTTON = 'Reset';
